import React from 'react';

export interface BoardNodesContextValue {
  selectedNodes: string[];
  handleRemoveNodesFromSelection: (nodeIDs: string) => void;
  handleAddToNodeSelection: (nodeIDs: string) => void;
  clearSelection: () => void;
  isBoardNodeCollapsedView: boolean;
  setIsBoardNodeCollapsedView: (value: boolean) => void;
  setSelectedNodes: React.Dispatch<React.SetStateAction<string[]>>;
}

// Create a context with initial value as null
export const BoardNodesContext = React.createContext<
  BoardNodesContextValue | undefined
>(undefined);
